import React, { FC, Fragment, useEffect, useState } from 'react'
import { Paper, Tabs, makeStyles, Tab, Hidden, Container } from '@material-ui/core'
import LocalParking from '@material-ui/icons/LocalParking';
import Build from '@material-ui/icons/Build'
import { useHistory, useLocation } from 'react-router-dom'
import { Redirect, Route, Switch } from 'react-router-dom'
import Groups from './groups'
import Plan from './plan'
import { RouteLocationProps } from '../../routes/alarms'
import * as ShortAPI from '../../api/short/index'
import * as ShortModels from '../../api/short/models'
import APIRequest from '../../components/helpers/APIRequest'

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
        //maxWidth: 500,
    },
    stickToBottom: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        // marginLeft: "-24px",
    },
    button: {
        minWidth: "unset",
    }
})

const InternalNavigation: FC = () => {
    const classes = useStyles()
    const history = useHistory()
    const routeLocation = useLocation<RouteLocationProps>()
    const {page} = (routeLocation.state) ? routeLocation.state : new RouteLocationProps()
    const [currentPage, setCurrentPage] = useState(-1)

    // List of locations
    const [locationData, setLocationData] = useState<ShortModels.Location[]>([])
    const [isPendingLocationData, setIsPendingLocationData] = useState(false)
    const [runRequestLocationData, setRunRequestLocationData] = useState(true)
    const [locationMap, setLocationMap] = useState<Map<number, string>>(new Map<number, string>())

    useEffect(() => {
        if (currentPage === -1 || currentPage !== page) {
            const {page} = (routeLocation.state) ? routeLocation.state : new RouteLocationProps()
            setCurrentPage(page)
        }
    }, [currentPage, page, routeLocation.state])

    useEffect(() => {
        // When the location list is downloaded, create the location map ID->name
        let newMap: Map<number, string> = new Map<number, string>()
        locationData.forEach(location => {
            newMap.set(location.id, location.name)
        })
        setLocationMap(newMap)
    }, [locationData])

    const changePage = (historyState: RouteLocationProps) => {
        setCurrentPage(historyState.page)

        switch (historyState.page) {
        case 0: // Groups
            history.push('/alarms/groupings', historyState)
            break
        case 1: // Plan
            history.push('/alarms/plan', historyState)
            break
        default:
            break
        }
    }
    const handleChange = (_: React.ChangeEvent<{}> | null, newValue: number) => {
        changePage(new RouteLocationProps(newValue))
    }

    const RequestData = () => {
        return (<APIRequest<ShortModels.Location[]>
            run={runRequestLocationData} setRun={setRunRequestLocationData}
            pending={isPendingLocationData} setIsPending={setIsPendingLocationData}
            req={ShortAPI.getLocations}
            setData={setLocationData}
        />)
    }

    return (
        <Fragment>
            <RequestData />
            <Hidden smDown>
                <Container>
                    <Paper square className={classes.root}>
                        <Tabs value={currentPage} onChange={handleChange} variant="fullWidth" indicatorColor="primary" textColor="primary" aria-label="icon label tabs example">
                            <Tab icon={<LocalParking />} label="Grupperinger" />
                            <Tab icon={<Build />} label="Vagtplan" />
                        </Tabs>
                    </Paper>
                </Container>
            </Hidden>
            <Switch>
                <Route exact path={`/alarms`}>
                    <Redirect to={`/alarms/groupings`}/>
                </Route>
                <Route path={`/alarms/groupings`}>
                    <Groups locationMap={locationMap} locationData={locationData} />
                </Route>
                <Route path={`/alarms/plan`}>
                    <Plan locationMap={locationMap} locationData={locationData} />
                </Route>
                <Route> <div>Siden bliv ikke fundet</div></Route>
            </Switch>
        </Fragment>
    )
}

export default InternalNavigation
